import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiUrlService {
  public apiUrl: string = window['__env'] && window['__env'].apiUrl ? `${window['__env'].apiUrl}/v1` : environment.apiUrl;
}